'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var actionTypes = {
    FETCH_MAUTIC_SEGMENTS_REQUEST: 'FETCH_MAUTIC_SEGMENTS_REQUEST',
    FETCH_MAUTIC_SEGMENTS_SUCCEEDED: 'FETCH_MAUTIC_SEGMENTS_SUCCEEDED',
    FETCH_MAUTIC_SEGMENTS_FAILED: 'FETCH_MAUTIC_SEGMENTS_FAILED'
};

function fetchMauticSegmentsRequest() {
    return {
        type: actionTypes.FETCH_MAUTIC_SEGMENTS_REQUEST
    };
}

function fetchMauticSegmentsSucceeded(segments) {
    return {
        type: actionTypes.FETCH_MAUTIC_SEGMENTS_SUCCEEDED,
        segments: segments
    };
}

function fetchMauticSegmentsFailed() {
    return {
        type: actionTypes.FETCH_MAUTIC_SEGMENTS_FAILED
    };
}

var actionCreators = {
    fetchMauticSegmentsRequest: fetchMauticSegmentsRequest,
    fetchMauticSegmentsSucceeded: fetchMauticSegmentsSucceeded,
    fetchMauticSegmentsFailed: fetchMauticSegmentsFailed
};

exports.actionTypes = actionTypes;
exports.actionCreators = actionCreators;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


//////////////////
// WEBPACK FOOTER
// ./src/client/actions/mautic.js
// module id = 271
// module chunks = 0